package de.oevbs.kunde.kundenportal2.navigation.components

import de.oevbs.kosmos.ui.icons.MaterialIconsFilled
import de.oevbs.kosmos.ui.icons.icon
import de.oevbs.kunde.kundenportal2.navigation.Page
import de.oevbs.kunde.kundenportal2.navigation.parents
import dev.fritz2.core.RenderContext

private fun RenderContext.breadcrumb(page: Page) {
    button("whitespace-nowrap") {
        +page.linkTitleShort
    }.clicks handledBy {
        page.target.visit()
    }
}

/**
 * Rendert eine Breadcrumbs-Komponente, die den Pfad zur übergeordneten Seite der angegebenen [page] als Folge
 * anklickbarer Pfadsegmente anzeigt.
 *
 * Die Breadcrumbs beinhalten folglich _nicht_ die aktuelle Seite selbst.
 *
 * Sie [Page.parents] für mehr Informationen zur Ermittlung des Pfades.
 */
fun RenderContext.breadcrumbs(page: Page) {
    val (head, tail) = page.parents.takeIf { it.isNotEmpty() }?.iterator()?.run {
        next() to asSequence()
    } ?: return

    div("w-full flex flex-row items-center gap-x-1 overflow-x-auto font-semibold text-primary-700") {
        breadcrumb(head)
        tail.forEach { subpage ->
            icon("w-5 h-5 shrink-0", icon = MaterialIconsFilled.chevron_right)
            breadcrumb(subpage)
        }
    }.domNode.run {
        // Wenn Scrollbar aktiv: Scrolle ans Ende, sodass die aktive Page sichtbar ist
        scrollLeft = scrollWidth.toDouble()
    }
}